// ============================================================================
// RHCancelamentoAdmissao.js
// Sub-módulo do RH: "Término do Contrato de Experiência" (nome de tela desde
// 16/09/2026; o código e as tabelas seguem em "cancelamento"). Mini-hub que hospeda as telas do
// fluxo (Candidatos / Solicitações / Destinatários), navegadas por abas internas
// conforme o perfil. Renderizado pelo hub RH (RH.js) como aba própria.
//
// Perfis:
//   • Candidatos    → Gerente (+ Admin) veem a PRÓPRIA loja e ABREM o pedido;
//                     RH/Diretoria veem a REDE inteira em LEITURA (acompanham os
//                     casos antes de o gerente pedir).
//   • Solicitações  → RH, Diretoria (+ Admin) decidem tudo; Gerente/Gerente
//                     Plantão veem só a PRÓPRIA loja (leitura).
//   • Destinatários → RH (+ Admin)                       — gere quem recebe o e-mail.
// ============================================================================

import { useState } from 'react';
import { CalendarX2, ClipboardList, Settings } from 'lucide-react';

import CancelamentoCandidatos from './RHCancelamentoAdmissao_Candidatos';
import CancelamentoFila from './RHCancelamentoAdmissao_Fila';
import CancelamentoDestinatarios from './RHCancelamentoAdmissao_Destinatarios';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

const COR = '#e11d48';
const COR_FUNDO = '#fff1f2';

function RHCancelamentoAdmissao() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = perfilNoModulo(user?.perfil, 'rh') || '';
  const isAdmin = role === 'Admin';
  const isRH = role === 'RH';
  const isDiretoria = role === 'Diretoria';
  // Só Gerente abre pedido (decisão do negócio). Gerente Plantão apenas lê a fila.
  const isGerente = role === 'Gerente';
  const isGerentePlantao = role === 'Gerente Plantao';

  const abas = [
    { key: 'candidatos', label: 'Candidatos', icon: <CalendarX2 size={16} />, show: isGerente || isAdmin || isRH || isDiretoria, Componente: CancelamentoCandidatos },
    { key: 'fila', label: 'Solicitações', icon: <ClipboardList size={16} />, show: isRH || isAdmin || isDiretoria || isGerente || isGerentePlantao, Componente: CancelamentoFila },
    { key: 'destinatarios', label: 'Destinatários', icon: <Settings size={16} />, show: isRH || isAdmin, Componente: CancelamentoDestinatarios },
  ].filter((a) => a.show);

  const [ativa, setAtiva] = useState(abas.length ? abas[0].key : null);

  if (!abas.length) {
    return <div style={{ padding: 24, color: '#64748b' }}>Sem telas disponíveis para o seu perfil.</div>;
  }

  const Componente = (abas.find((a) => a.key === ativa) || abas[0]).Componente;

  return (
    <div>
      {abas.length > 1 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 24, borderBottom: '1px solid #f0e2e2', paddingBottom: 16 }}>
          {abas.map((a) => {
            const on = a.key === ativa;
            return (
              <button
                key={a.key}
                onClick={() => setAtiva(a.key)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8, padding: '10px 18px', borderRadius: 8,
                  fontWeight: 700, fontSize: 14, cursor: 'pointer', transition: 'all 0.2s',
                  border: on ? `1px solid ${COR}` : '1px solid #e2e8f0',
                  background: on ? COR_FUNDO : '#fff',
                  color: on ? COR : '#64748b',
                }}
              >
                {a.icon} {a.label}
              </button>
            );
          })}
        </div>
      )}

      <Componente />
    </div>
  );
}

export default RHCancelamentoAdmissao;
